// Dependency-network view (wireframe 05) — render_dependency_network.
// Renders the widget directly without ArtifactView's metarow so the
// layout toolbar + node-count summary sit flush against the chart.

import { NetworkGraphWidget } from "../components/widgets/NetworkGraphWidget.js";
import { useShell } from "../components/ShellContext.js";
import { useTool } from "../lib/useTool.js";
import { ErrorState, Skeleton } from "./common.js";

export default function DependencyNetworkView() {
  const { project } = useShell();
  const { env, loading, error, refetch } = useTool("render_dependency_network", { project });

  if (loading) return <Skeleton lines={4} />;
  if (error) return <ErrorState error={error} onRetry={refetch} />;
  if (!env) return <ErrorState error="render_dependency_network returned no envelope" onRetry={refetch} />;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-lg border border-slate-200 bg-white">
      <NetworkGraphWidget data={env.data} />
    </div>
  );
}
